import React from "react";

const Pane = ({ children }) => {
  return <div className="pane">{children}</div>;
};

export default Pane;
